(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scroll) {
    if (scroll.dataset.csInit) return;
    scroll.dataset.csInit = '1';
    var root = scroll.querySelector('.cshowcase');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.cshowcase__panel'));
    if (panels.length < 2) { scroll.classList.add('is-in'); return; }

    var mqMobile = window.matchMedia('(max-width: 749px)');
    var N = panels.length;
    var EXPAND = 4; // how much extra grow the focused panel gets vs a collapsed one

    // discrete class toggle (labels/zoom/dots) — used by desktop hover
    function setActiveClass(i) {
      i = Math.max(0, Math.min(N - 1, i));
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var rect = scroll.getBoundingClientRect();
        // reveal the moment the section scrolls into view (entrance = scroll-tied)
        if (rect.top < window.innerHeight && rect.bottom > 0) scroll.classList.add('is-in');
        if (!mqMobile.matches) {
          panels.forEach(function (p) { p.style.flexGrow = ''; });
          return;
        }
        var scrollable = scroll.offsetHeight - root.offsetHeight;
        if (scrollable <= 0) return;
        var scrolled = Math.min(Math.max(-rect.top, 0), scrollable);
        // "focus" glides continuously from 0 → N-1 as you scroll the track.
        // Each panel's size is a smooth function of its distance from focus,
        // so two neighbours share the expansion mid-scroll (no snapping / dead
        // zones). Labels/zoom follow the nearest panel.
        var focus = (scrolled / scrollable) * (N - 1);
        var nearest = Math.round(focus);
        panels.forEach(function (p, i) {
          var d = Math.abs(i - focus);
          var w = d < 1 ? 1 - d : 0;
          w = w * w * (3 - 2 * w); // smoothstep for a softer ramp
          p.style.flexGrow = (1 + EXPAND * w).toFixed(3);
          p.classList.toggle('is-active', i === nearest);
        });
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);

    // desktop: hover to activate
    panels.forEach(function (p, i) {
      p.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover) and (min-width: 750px)').matches) setActiveClass(i);
      });
    });

    setActiveClass(0);
    onScroll();
  }

  function boot() { document.querySelectorAll('.cshowcase-scroll').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
